import { WorkOrderModel } from 'models';
import { atom } from 'recoil';

export const workOrderState = atom({
    key: 'workOrder',
    default: {
        orderData: null as unknown as WorkOrderModel
    }
});
